import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";

export const ImageSection = ({ name }) => {
  return (
    <>
      <section
        className="p-6 py-10 lg:py-20 xl:py-24 3xl:py-28  h-full w-full relative
         bg-[url('../public/images/background_img/red_textile_background.png')] bg-[75%] lg:bg-left bg-no-repeat bg-cover"
        id="home"
      >
        <div className="mx-auto lg:mx-10 xl:mx-14 2xl:mx-36 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 ">
            <div className="span-col-1 flex justify-center lg:justify-start items-center ">
              <h3
                className="lg:pl-0 font-normal leading-normal text-xl md:text-3xl lg:text-4xl
               2xl:text-5xl text-white flex flex-col lg:flex-row justify-center items-center gap-3 lg:gap-6"
              >
                {name}
                <MdOutlineArrowForwardIos className="rotate-90 lg:rotate-0" />
              </h3>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ImageSection;
